import React, { FC } from 'react'
import { SubscribeBottomCTA } from './style'

//* utils
import { ASSETS } from '../../../constants/assets'
import { ComponentSubscribe } from '../../../models/components/subscribe'
import ImageUtils from '../../../utils/img.utils'

//* components
import Button from '../button'
import Typography from '../typography'

type Props = {
  data: ComponentSubscribe | null
}

const Subscribe: FC<Props> = ({ data }) => {
  const postHeadline = data?.postHeadline || ''
  const backgroundDesktopUrl = ImageUtils.getResizedImageUrl(ASSETS.MAIN_CTA_LARGE, '')
  const backgroundMobileUrl = ImageUtils.getResizedImageUrl(ASSETS.MAIN_CTA_SMALL, '')

  return (
    <SubscribeBottomCTA
      $backgroundDesktop={backgroundDesktopUrl}
      $backgroundMobile={backgroundMobileUrl}
      data-cy="Subscribe">
      <div>
        {postHeadline && <Typography type="header2">{postHeadline}</Typography>}

        <Button
          icon={true}
          href="javascript:void(0);"
          text="Subscribe"
          type="primary"
          size="small"
          theme="light"
          className="SubscribeModal__Trigger"
        />
      </div>
    </SubscribeBottomCTA>
  )
}

export default Subscribe
